/**
 * Owner: Masa Bayu
 * File: PrivateAuthorMobileSubHeader.tsx
 * Date:Time: 2026-10-19 04:55
 * Description: Kepala sub-paparan mudah alih PRIVAT §390 dengan butang
 *   kembali ke Home (pola skrin kanan mockup).
 */

import type { ReactElement } from 'react';

export interface MobileSubHeaderProps {
  readonly title: string;
  readonly sub?: string;
  readonly onBack: () => void;
  readonly backAria: string;
}

export function MobileSubHeader({
  title,
  sub,
  onBack,
  backAria,
}: MobileSubHeaderProps): ReactElement {
  return (
    <header className="qxpm__subhead">
      <button type="button" className="qxpm__back" aria-label={backAria} onClick={onBack}>
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M15 5l-7 7 7 7" />
        </svg>
      </button>
      <div>
        <h1 className="qxpm__subhead-title">{title}</h1>
        {sub !== undefined ? <p className="qxpm__subhead-sub">{sub}</p> : null}
      </div>
    </header>
  );
}
